module.exports = __webpack_public_path__ + "img/白术.2170d3b1.jpg";